import { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'clsx';
import flow from 'lodash/flow';
import noop from 'lodash/noop';

import AuthAndPaymentFlowHeader from '../shared/AuthAndPaymentFlowHeader';

import viewTypes from '../../constants/auth/viewTypes';

import connectWithExperiments from '../../decorators/connectWithExperiments';
import { AUTH_PAYMENT_FORM_PREVIEW_ENABLED } from '../../constants/experiments/auth';
import {
  CREATE_AN_ACCOUNT,
  SIGN_IN,
  SIGN_IN_OR_SIGN_UP_SUBTITLE,
} from '../../constants/localizations/auth';
import { PAYMENT_FLOW } from '../../constants/subscription/flow';
import { LocationAndLocalizationContext } from '../../providers/LocationAndLocalizationProvider';
import css from './fake-auth-view-container.module.scss';
import authCss from './auth.module.scss';
import authViewContainerCss from './auth-view-container.module.scss';
import SignUpView from './SignUpView';
import SignInView from './SignInView';

// exported for testing
export class FakeAuthViewContainer extends Component {
  static propTypes = {
    viewType: PropTypes.string,
    startFakeAuthTransition: PropTypes.func.isRequired,
    isRecurlyLoading: PropTypes.bool.isRequired,
    [AUTH_PAYMENT_FORM_PREVIEW_ENABLED]: PropTypes.bool,
  };

  static contextType = LocationAndLocalizationContext;

  render() {
    const { viewType, startFakeAuthTransition, isRecurlyLoading } = this.props;
    const { location } = this.context;

    if (!this.props[AUTH_PAYMENT_FORM_PREVIEW_ENABLED]) {
      return null;
    }

    if (!location.query[PAYMENT_FLOW]) {
      return null;
    }

    const commonProps = {
      actions: {
        loginWithOauth: noop,
        loginWithEmail: noop,
        createAccount: noop,
        createAccountWithOauth: noop,
        trackSignUpPage: noop,
      },
      failAuthNotice: '',
      successAuthNotice: '',
      isDialog: false,
      isPaymentFlow: true,
    };

    const authViewTransition = isRecurlyLoading ? '' : css.authViewTransition;
    const ref = isRecurlyLoading ? noop : startFakeAuthTransition;

    return (
      <div ref={ref}>
        <div
          className={classNames(
            authViewContainerCss.container,
            authCss.withFormSections,
            authCss.fullScreen,
            authViewTransition,
          )}
        >
          {viewType === viewTypes.signIn ? (
            <div style={{ position: 'relative' }}>
              <div className={css.overlay} data-testid="authFormOverlay" />
              <AuthAndPaymentFlowHeader
                header={SIGN_IN}
                subheader={SIGN_IN_OR_SIGN_UP_SUBTITLE}
              />
              <SignInView
                key="signInView"
                handleChangeToSignUp={noop}
                handleChangeToForgotPassword={noop}
                {...commonProps}
              />
            </div>
          ) : (
            <div style={{ position: 'relative' }}>
              <div className={css.overlay} data-testid="authFormOverlay" />
              <AuthAndPaymentFlowHeader
                header={CREATE_AN_ACCOUNT}
                subheader={SIGN_IN_OR_SIGN_UP_SUBTITLE}
              />
              <SignUpView
                key="signUpView"
                handleChangeToSignIn={noop}
                {...commonProps}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default flow(
  connectWithExperiments([AUTH_PAYMENT_FORM_PREVIEW_ENABLED]),
)(FakeAuthViewContainer);
